module.exports = __webpack_public_path__ + "media/images/haircut/card-desktop-c53ed321c8f9192e0862e010b293f98e.jpg";